export default (hex) => {
  let str = hex.replace(/^#/, '');

  if (str.length === 3) {
    str = str[0] + str[0] + str[1] + str[1] + str[2] + str[2];
  }

  const num = parseInt(str, 16);

  /* eslint-disable */
  return [num >> 16, num >> 8 & 255, num & 255];
  /* eslint-enable */
};



// WEBPACK FOOTER //
// ./src/styles/hexToRgb.js